import axios, { AxiosRequestConfig } from 'axios'
import { IApiRequestResult, IRequestConfig, useApi } from '../hooks/useApi'
import { IFeatureFlag } from '../types/config-api-types'

export type IConfigApi = ReturnType<typeof useConfigApi>

export default function useConfigApi() {
    const configApiBaseAddress = `${window.config.CONFIG_API_URL}/api`
    const { executeUnauthenticated, execute } = useApi()

    const getGlobalFeatureFlagsAsync = async (): Promise<
        IApiRequestResult<IFeatureFlag[]>
    > => {
        return executeUnauthenticated(async (cfg: IRequestConfig) => {
            const { data } = await axios.get<IFeatureFlag[]>(
                `${configApiBaseAddress}/global-feature-flags`,
                cfg as AxiosRequestConfig
            )
            return data
        })
    }

    const getServiceFeatureFlagsAsync = async (): Promise<
        IApiRequestResult<IFeatureFlag[]>
    > => {
        return execute(async (cfg: IRequestConfig) => {
            const { data } = await axios.get<IFeatureFlag[]>(
                `${configApiBaseAddress}/feature-flags`,
                cfg as AxiosRequestConfig
            )
            return data
        })
    }

    return {
        getGlobalFeatureFlagsAsync,
        getServiceFeatureFlagsAsync,
    }
}
